<template>
  <div class="bg-white rounded-2xl shadow-md p-4">
    <div class="flex items-center justify-between mb-4">
      <h3 class="text-lg font-bold text-gray-900">Contrat</h3>
      <div class="flex items-center gap-2">
        <FieldSpan v-if="claim.category" class="bg-blue-100 text-blue-800" :value="claim.category" />
        <FieldSpan
          :class="[statusBadgeClass(planSale)]"
          translation-prefix="planSale.status"
          :value="planSale.status"
        />
      </div>
    </div>

    <div class="grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-2">
      <StackedField label="Numéro contrat" class="col-span-2">
        <span class="font-light text-primary">
          {{ planSale.friendlyId }}
        </span>
      </StackedField>
      <StackedField label="Adhérent" :value="`${customer.firstName} ${customer.lastName}`" />
      <StackedField label="Date d'adhésion" :value="planSale.date" />
      <StackedField label="Date d'expiration" :value="planSaleExpiration" />
      <StackedField
        v-if="replacementHandlingType && claim.compensationValue"
        label="Max. prise en charge"
        class="col-span-2"
        :value="formatPrice(claim.compensationValue)"
      />
    </div>
  </div>
</template>

<script>
import { StackedField, FieldSpan, formatPrice } from "@estaly/ui";
import { mapGetters } from "vuex";

export default {
  props: ["claim", "replacementHandlingType"],
  components: {
    StackedField,
    FieldSpan,
  },

  computed: {
    ...mapGetters("planSales", ["statusBadgeClass"]),

    planSale() {
      return this.claim.planSale;
    },

    claimProduct() {
      return this.claim.claimProduct;
    },

    customer() {
      return this.claim.customer;
    },

    planSaleExpiration() {
      return this.planSale.recurring ? "Tacite reconduction" : this.planSale.expirationDate;
    },
  },

  methods: {
    formatPrice,
  },
};
</script>
